import { render } from "./MenuItemsGroup.vue?vue&type=template&id=3cc5f35e&scoped=true"
import script from "./MenuItemsGroup.vue?vue&type=script&lang=js"
export * from "./MenuItemsGroup.vue?vue&type=script&lang=js"

import "./MenuItemsGroup.vue?vue&type=style&index=0&id=3cc5f35e&lang=scss&scoped=true"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cc5f35e"]])

export default __exports__